import { render } from "./DailyNewAppointments.vue?vue&type=template&id=2a81cbb2"
import script from "./DailyNewAppointments.vue?vue&type=script&lang=js"
export * from "./DailyNewAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__